import React from 'react'
import { useWaveform } from '@mote/helpers/hooks/business'
import {
  useAudioAnimation,
  useAudioStream
} from '@mote/presentation/src/shared/hooks'
import { Block, Button, ButtonGroup, H4 } from '@mote/ui'
import { Content } from '../../layouts/shared/content'

export const LabsWaveformScreen = () => {
  const { start, stop, audioContext, audioStream } = useAudioStream()
  const {
    beginAnimation: startAmplitudeAnimation,
    endAnimation: stopAmplitudeAnimation,
    amplitude
  } = useAudioAnimation(audioContext, audioStream)

  function handleStop() {
    stop()
    stopAmplitudeAnimation()
  }

  return (
    <Content>
      <Block gap={48} margin='40px 0'>
        <H4>Microphone Audio Visualizations</H4>
        <ButtonGroup>
          <Button onClick={() => start()} text='Start mic' />
          <Button onClick={handleStop} text='Stop mic' />
        </ButtonGroup>
        <NativeWaveform
          audioContext={audioContext}
          audioStream={audioStream}
          onStop={stop}
        />
        <Block gap={24}>
          <H4>Amplitude</H4>
          <div
            style={{
              width: '100px',
              height: '100px',
              background: '#AC0AE8',
              borderRadius: '100%',
              transform: `scale(${1 + amplitude * 3})`,
              transition: 'transform 50ms ease-in-out'
            }}
          />
          <ButtonGroup>
            <Button onClick={startAmplitudeAnimation} text='Start amplitude' />
            <Button onClick={stopAmplitudeAnimation} text='Stop amplitude' />
          </ButtonGroup>
        </Block>
      </Block>
    </Content>
  )
}

const NativeWaveform = ({ audioContext, audioStream, onStop }) => {
  const { waveFormContainerRef, bars, beginAnimation, endAnimation } =
    useWaveform(audioContext, audioStream)

  return (
    <Block gap={24}>
      <H4>Waveform</H4>
      <Block
        ref={waveFormContainerRef}
        layout='horizontal'
        align='center'
        gap={4}
        height={30}
        width='max-content'
      >
        {bars.map(num => (
          <div
            data-waveform-bar={num}
            key={num}
            style={{
              width: 3,
              background: '#ECECF3',
              minHeight: 3,
              height: 3,
              maxHeight: 30,
              borderRadius: 3,
              flexShrink: 0
            }}
          />
        ))}
      </Block>
      <ButtonGroup>
        <Button onClick={() => beginAnimation()} text='Start waveform' />
        <Button
          onClick={() => {
            endAnimation()
            onStop()
          }}
          text='Stop waveform'
        />
      </ButtonGroup>
    </Block>
  )
}
